import Axios from './base';

export const GetTemplatesForModule = (module) =>
    Axios().get(`CommunicationTemplate/ForModule/${module}`);

export const PreviewCommunicationTemplate = (templateId, module, entityId) =>
    Axios().post('CommunicationTemplate/Preview', { templateId, module, entityId });

export const SendCommunicationTemplate = (templateId, module, entityId, recipientEmail) =>
    Axios('Email sent successfully').post('CommunicationTemplate/Send', { templateId, module, entityId, recipientEmail });
